export default __webpack_public_path__ + "static/medium-image-applozic-2-82bc1b7708a4b6a9f234419a9844e494.png";